export const formatCreateDate = (date: string): string => {
  let array = []
  const newDate = date.substr(0, 10)
  array = newDate.split('-')
  const year = array[0] + '年'
  const month = Number(array[1]) + '月'
  const day = Number(array[2]) + '日'
  return year + month + day
}

export const getCookieArray = (): string[] => {
  if (process.browser) {
    const arr = []
    if (document.cookie != '') {
      const tmp = document.cookie.split('; ')
      for (let i = 0; i < tmp.length; i++) {
        const data = tmp[i].split('=')
        arr[data[0]] = decodeURIComponent(data[1])
      }
    }
    return arr
  }
}
export const deleteAllCookies = () => {
  const cookies = document.cookie.split(';')
  for (let i = 0; i < cookies.length; i++) deleteCookie(cookies[i].split('=')[0])
}

export const setCookie = (name: string, value: string, expireDate: number): void => {
  const d = new Date()
  d.setTime(d.getTime() + expireDate * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  document.cookie = name + '=' + value + '; ' + expires
}

export const deleteCookie = (name) => {
  setCookie(name, '', -1)
}

export const createPaginationArray = (currentPage, totalPages, isPC) => {
  const loopableArray = [];

  if (totalPages === 1) {
    return [1];
  }

  let pagesToShow = isPC ? 2 : 1;

  if (!isPC) {
    if (currentPage === 1) {
      pagesToShow = 2;
    } else if (currentPage === totalPages) {
      pagesToShow = 2;
    }
  }

  for (let i = pagesToShow; i > 0; i--) {
    if (currentPage - i > 0) {
      loopableArray.push(currentPage - i);
    }
  }

  loopableArray.push(currentPage);

  for (let i = 1; i <= pagesToShow; i++) {
    if (currentPage + i <= totalPages) {
      loopableArray.push(currentPage + i);
    }
  }

  if (loopableArray[0] > 2) {
    loopableArray.unshift('...');
    loopableArray.unshift(1);
  } else if (loopableArray[0] !== 1) {
    loopableArray.unshift(1);
  }
  if (loopableArray[loopableArray.length - 1] < totalPages - 1) {
    loopableArray.push('...');
    loopableArray.push(totalPages);
  } else if (loopableArray[loopableArray.length - 1] !== totalPages) {
    loopableArray.push(totalPages);
  }
  return loopableArray;
};


export const addGTMToBody = () => {
  if (process.browser) {
    if (!document.querySelector('.gtm')) {
      const iframe = document.createElement('iframe')
      iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-T2H2T5X'
      iframe.style.width = '0'
      iframe.style.height = '0'
      iframe.style.display = 'none'
      iframe.style.visibility = 'hidden'
      iframe.classList.add('gtm')
      document.body.insertAdjacentHTML('afterbegin', iframe.outerHTML)
    }
  }
  return
}
